<template>
  <svg width="300" height="470" viewBox="0 0 300 470" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'MEMBERSHIP'">
    <rect opacity="0.6" x="2" y="2" width="296" height="466" rx="18" :stroke="`url(#paint-${color})`" stroke-width="4"/>
  </svg>
  <svg width="300" height="490" viewBox="0 0 300 490" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'TICKET'">
    <path opacity="0.6" d="M4.73141 350.933C8.43445 349.166 11 345.385 11 341C11 336.615 8.43445 332.834 4.73143 331.067C2.94087 330.213 2 329.012 2 328V20C2 10.0589 10.0589 2 20 2H280C289.941 2 298 10.0589 298 20V328C298 329.012 297.059 330.213 295.269 331.067C291.566 332.834 289 336.615 289 341C289 345.385 291.566 349.166 295.269 350.933C297.059 351.787 298 352.988 298 354V470C298 479.941 289.941 488 280 488H181.502C179.33 488 177.106 486.092 175.888 483.395C172.641 476.211 164.318 468 150 468C135.682 468 127.359 476.211 124.112 483.395C122.894 486.092 120.67 488 118.498 488H20C10.0589 488 2 479.941 2 470V354C2 352.988 2.94087 351.787 4.73141 350.933Z" :stroke="`url(#paint-${color})`" stroke-width="4"/>
  </svg>
  <svg class="svg_defs" xmlns="http://www.w3.org/2000/svg" width="0" height="0">
    <defs>
      <linearGradient id="paint-yellow" x1="1.89993e-08" y1="212.029" x2="300.023" y2="217.158" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFEB2C"/>
        <stop offset="0.405208" stop-color="#FFFBD5"/>
        <stop offset="0.780208" stop-color="#FFC9EE"/>
      </linearGradient>
      <linearGradient id="paint-blue" x1="-1.7418e-07" y1="171.427" x2="299.977" y2="177.771" gradientUnits="userSpaceOnUse">
        <stop stop-color="#4AD3FF"/>
        <stop offset="0.405208" stop-color="#C8F4FF"/>
        <stop offset="0.780208" stop-color="#B2CCFF"/>
      </linearGradient>
      <linearGradient id="paint-orange" x1="-1.7418e-07" y1="171.427" x2="299.977" y2="177.771" gradientUnits="userSpaceOnUse">
        <stop stop-color="#F7888E"/>
        <stop offset="0.405208" stop-color="#FFD9DA"/>
        <stop offset="0.780208" stop-color="#B2CCFF"/>
      </linearGradient>
      <linearGradient id="paint-yellow" x1="1.89993e-08" y1="212.029" x2="300.023" y2="217.158" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFEB2C"/>
        <stop offset="0.405208" stop-color="#FFFBD5"/>
        <stop offset="0.780208" stop-color="#FFC9EE"/>
      </linearGradient>
      <linearGradient id="paint-green" x1="1.89993e-08" y1="212.029" x2="300.023" y2="217.158" gradientUnits="userSpaceOnUse">
        <stop stop-color="#B7FFDD"/>
        <stop offset="0.405208" stop-color="#E3FFE4"/>
        <stop offset="0.780208" stop-color="#ABC5FE"/>
      </linearGradient>
      <linearGradient id="paint-pink" x1="0.000214246" y1="180" x2="299.989" y2="186.041" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFA8A9"/>
        <stop offset="0.405208" stop-color="#FFE4F6"/>
        <stop offset="0.780208" stop-color="#D7A7FF"/>
      </linearGradient>
    </defs>
  </svg>

</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  props: {
    type: {
      default: 'MEMBERSHIP',
    },
    color: {
      default: 'pink',
    }
  }
})
</script>
